import { React, useEffect } from "react";
import "./Terms-Conditions.css";
import { Link, useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import { Nav } from "react-bootstrap";
import { Navbar } from "react-bootstrap";
import { Form, Button } from "react-bootstrap";
import { FiChevronDown } from "react-icons/fi";
import { Helmet } from "react-helmet";

const Termsconditions = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the new URL
    navigate("/terms-conditions");
  }, [navigate]);

  return (
    <div>
      <Helmet>
        <title>Terms and conditions | BettDraft Fantasy Sports</title>

        <meta
          name="description"
          content="Read more about BettDraft's Terms and conditions."
        />

        <link
          rel="canonical"
          href="https://dfs.bettdraft.com/terms-conditions"
        />
      </Helmet>
      <div className="container bg-color-tc space-bottom">
        <div className="inner-smallspace-tc">
          <div className="row">
            <div className="col-md-12">
              <div className="content-page-design">
                <h2>1. TERMS AND CONDITIONS</h2>

                <h4 style={{ color: "whitesmoke!important", fontSize: "15px" }}>
                  IMPORTANT NOTICE: PLEASE READ AND CAREFULLY REVIEW THESE
                  TERMS. THEY CONTAIN AND ARE SUBJECT TO BINDING ARBITRATION AND
                  A WAIVER OF CLASS ACTION RIGHTS AS DETAILED IN THIS AGREEMENT.
                  IT IS YOUR RIGHT TO SEEK LEGAL ADVICE BEFORE ACCEPTING THESE
                  TERMS AND PARTICIPATING IN OR ENGAGING WITH ANY OF OUR
                  CONTENT. WE ENCOURAGE YOU TO DO SO BEFORE PROCEEDING.
                </h4>
                <br />

                <h4>1.1 Acceptance of Terms.</h4>
                <p>
                  BettDraft, Inc (collectively referred to as “We”, “Us”, or
                  “BettDraft”) operates BettDraft.com (the "Site") and its
                  associated mobile apps, providing access to skill-based
                  fantasy sports contests, promotions, and other services.
                  Before using any of the services provided by BettDraft, please
                  review this Agreement carefully. By registering an account
                  with BettDraft.com and agreeing to these Terms via the website
                  or associated mobile app, you accept this agreement, the
                  Privacy Policy, House Rules, and any additional rules, in
                  their entirety and without reservation. This Agreement
                  constitutes a legally binding agreement between You and
                  BettDraft. Along with the Privacy Policy and House Rules, it
                  governs your use of the BettDraft online platform, software,
                  and any services provided herein. You confirm that you are the
                  sole owner and operator of your account and that you have
                  provided correct and accurate information while creating your
                  registered account. You agree that you will only create and
                  retain one account at BettDraft, which must be in your own
                  legal name. You are not permitted to access the BettDraft
                  website, apps, or services using another person’s account or
                  an account that does not directly belong to you. You also
                  agree not to create or obtain more than one account or access
                  an account belonging to another person, or allow another
                  person to access your account. Violating this Agreement will
                  result in termination of all associated accounts, forfeiture
                  of any competition winnings, and your account will be flagged
                  for investigation and blocked from future access to BettDraft
                  services.
                </p>
                <p>
                  BettDraft reserves the right to modify, suspend, remove or add
                  to the software and/or services at any time, without prior
                  notice. BettDraft shall not be liable for any loss suffered by
                  You, including, but not limited to any indirect,
                  consequential, incidental, or special damages, resulting from
                  any changes made to the software and/or services. You may not
                  initiate any claims against BettDraft in such regard.
                </p>

                <p>
                  If you do not agree to these terms, you are not authorized to
                  use the website, app or services provided by BettDraft. It is
                  solely your responsibility to refrain from creating,
                  accessing, engaging with and/or using the services provided by
                  BettDraft if you do not agree to these terms. BettDraft will
                  not be held liable for any incident resulting from access by a
                  patron who does not agree to these terms.
                </p>
                <br />

                <h4>2. Modification of Terms of Use</h4>
                <p>
                  {" "}
                  BettDraft may modify or replace the Terms and Conditions,
                  Privacy Policy or House Rules at any time, except for
                  provisions regarding binding arbitration and waiver of class
                  action rights, at its sole discretion. The latest version of
                  this Agreement will be accessible on the Site and App. All
                  contests will be governed by the Terms and Conditions that are
                  in effect at the start of the contest. Any actions related to
                  fraud, misrepresentation, cheating, theft, or other conduct
                  deemed to be improper by BettDraft will be governed by the
                  most recent version of the Terms and Conditions. It is your
                  responsibility to check the Terms and Conditions periodically
                  for changes, and you must review and become familiar with any
                  modifications to the Terms. If a revision to the Terms and
                  Conditions is material, we will notify you via the App or Site
                  notification and/or by contacting you through the email
                  address associated with your account. The Parties agree that
                  any means of notification described herein are reasonable and
                  acceptable. The Parties also agree that any notification
                  received within a reasonable timeframe following revision(s)
                  to the Terms and Conditions is appropriate and sufficient for
                  providing the necessary notice of such revision(s). Your use
                  of the Services, including logging into your Account or
                  accessing the App or Site for any othe r purpose than
                  exclusively reviewing this Agreement, after any
                  modification(s) or revision(s) to them constitutes your full
                  acceptance of the modified or revised Terms and Conditions.
                </p>

                <p>
                  BettDraft reserves the right to modify, suspend, or
                  discontinue the Services, including any content, feature, or
                  database, whether temporarily or permanently, at any time and
                  for any reason. BettDraft may also impose limits on certain
                  features and services or restrict your access to parts or all
                  of the Services without notice or liability. You agree that
                  BettDraft shall not be liable to you or any third party for
                  any modification, suspension, or discontinuation of any
                  Services.
                </p>

                <h4>3. Eligibility and Participation</h4>

                <p>
                  <b>Age and Personal Information:</b>
                </p>

                <p>
                  No person under 18 years of age is permitted to download,
                  access, use, obtain an account to access or participate in any
                  competitions, promotions or services offered by BettDraft. Any
                  persons who are unable to validate their age by means of
                  providing copies of government issued identification
                  confirming they are eligible to obtain and retain an account
                  will have their account immediately deactivated and any future
                  access blocked.
                </p>

                <p>
                  Access is not currently permitted if you are physically
                  located in the state of Alabama, Arizona, Colorado,
                  Connecticut, Delaware, Florida, Hawaii, Idaho, Indiana, Iowa,
                  Louisiana, Maine, Maryland, Massachusetts, Michigan,
                  Mississippi, Missouri, Montana, Nevada, New Hampshire, New
                  Jersey, New York, North Carolina, Ohio, Pennsylvania,
                  Tennessee, Virginia, Washington, West Virginia or Wyoming.
                  BettDraft reserves the right to restrict access to anyone
                  deemed to be under the minimum age requirements when accessing
                  the service in any of the previously mentioned states.
                </p>

                <p>
                  By using the Services, you agree that we may verify the
                  personal information you provided during the registration
                  process, including your name, physical address, date of birth,
                  driver's license, government-issued identity card, social
                  security number, and passport identification for non-US
                  residents, in order to confirm that you are Legally of Age and
                  to verify your identity. To perform these checks, we may use
                  third-party verification services, such as credit reference
                  agencies or identification verification services, which may
                  keep a record of your information and could affect your credit
                  report. This verification process is necessary to confirm your
                  age, identity, and location and, if necessary, your source of
                  funds. We reserve the right to verify that you have not
                  previously self-excluded with us, any State Regulators, or any
                  program offered by a governmental agency, and that you are not
                  on any State Regulator's self-exclusion list.
                </p>

                <p>
                  To verify your information, we may request certain documents,
                  including an identity card, proof of address, and proof of
                  payment method, which can be sent to us through the methods we
                  designate. We may also request notarized document copies,
                  which must be stamped and attested to by a notary public, at
                  our sole discretion. If your requested documents are not
                  completed to our satisfaction, we may inactivate your account
                  and withhold any funds present therein, and any initial
                  deposit funds will be returned to you. We may also refuse to
                  refund any bonuses or winning funds provided to or gained by
                  you at our sole discretion.
                </p>

                <p>
                  If the documents fail our internal security check, for
                  example, if we suspect that the documents have been tampered
                  with or provided to mislead or misrepresent, we shall be under
                  no obligation to accept such documents as valid and shall be
                  under no obligation to provide feedback on the exact nature of
                  our findings with regard to the documents. We reserve the
                  right, at our sole discretion, to request additional
                  information from you or as required by law.
                </p>

                <p>
                  Until your age, identity, and location, and if necessary, your
                  source of funds, have been verified to our satisfaction, you
                  will not be permitted full access to BettDraft software and
                  services.
                </p>

                <p>
                  You explicitly consent to BettDraft conducting background
                  checks on You for any reason related to the BettDraft
                  Services, including, but not limited to, investigating Your
                  identity, performing credit checks, or inquiring into Your
                  personal history. The specific purpose of such investigations
                  may include verifying Your registration details such as name,
                  address, and age, transactions and gaming activity. BettDraft
                  may not inform You of such an investigation taking place, and
                  may use social media sites to conduct it. Third-party
                  companies may also be employed by BettDraft to conduct
                  investigations when required. At BettDraft’s sole discretion,
                  it may choose to block Your account and withhold all funds
                  based on the findings of such an investigation.
                </p>

                <p>
                  By using the Services, you expressly agree that BettDraft may
                  disclose your information, such as contest entries, to
                  government authorities, self-regulatory bodies, and other
                  private operators or suppliers, for integrity services.
                  Additionally, BettDraft may share your information with its
                  partners, vendors, and suppliers. BettDraft may also share
                  your information with its parent companies, subsidiaries, and
                  affiliates. These companies may collectively use your
                  information for any purpose in accordance with their
                  respective privacy policies and applicable law.
                </p>

                <p>
                  <b>Location Verification:</b>
                </p>

                <p>
                  You must be a resident or citizen of the United States of
                  America, have and provide your Social Security Number and
                  residential address within the United States of America to
                  obtain and retain an account. You are required to be
                  physically located within an authorized jurisdiction within
                  the United States of America in order to deposit funds,
                  participate in or process a competition, game or promotion
                  entry at BettDraft. BettDraft reserve the right to restrict
                  access if you are physically located outside of an eligible
                  jurisdiction.
                </p>

                {/* <p>
                 If you are located in Louisiana at the time processing a deposit or entering a contest, promotion or game, you are prohibited from activity in the following parishes: Allen, Avoyelles, Beauregard, Caldwell, Catahoula, Franklin, Grant, Jackson, Jefferson, Davis, LaSalle, Morehouse, Richland, Sabine, Union, Vernon, West Carroll, Winn.
                 </p> */}

                <p>
                  You are not permitted to process a deposit or enter a contest,
                  promotion or game if you are physically located in any of the
                  following states: Alabama, Arizona, Colorado, Connecticut,
                  Delaware, Florida, Hawaii, Idaho, Indiana, Iowa, Louisiana,
                  Maine, Maryland, Massachusetts, Michigan, Mississippi,
                  Missouri, Montana, Nevada, New Hampshire, New Jersey, New
                  York, North Carolina, Ohio, Pennsylvania, Tennessee, Virginia,
                  Washington, West Virginia or Wyoming. BettDraft makes no
                  representation that paid entry fantasy sports contests
                  participation is lawful under Texas state law.
                </p>

                <p>
                  You acknowledge and agree that during any real-money
                  transactions, you will be physically present within the
                  geographical boundaries of an Authorized Jurisdiction and will
                  comply with our requirements to verify your physical location
                  at the time of deposit, withdrawal or contest entry, including
                  by using your mobile device's current location or the Wi-Fi
                  networks when using your computer. Location coordinates may be
                  collected at any time and you have agreed to use the location
                  verification services on your devices to permit the collection
                  of location coordinates. After completing the account
                  registration process and before depositing funds or entering
                  real money contests, you may be required to download a
                  “plugin” from our Location Service provider. You hereby
                  consent to your location being verified via the
                  above-described process each time you log in to your account
                  and periodically while you are logged in to your account.
                </p>

                <p>
                  You acknowledge and agree that you are granted a personal,
                  non-transferable, and non-exclusive right to use the Location
                  Service and any data related to it. GeoComply, the provider of
                  the Location Service, and/or its licensors, retain all their
                  intellectual property rights in and to the Location Service,
                  and no title to any such property is transferred to you. You
                  agree not to expose, reverse assemble, reverse engineer,
                  decompile, reverse decompile, reduce to human-readable form,
                  or otherwise attempt to derive source code from the Location
                  Service or modify, incorporate into or with other software, or
                  create derivative works of the Location Service or any data
                  related to it or allow any third party to do so. You agree not
                  to expose, capture, retain, aggregate, store, copy, market,
                  modify, reverse engineer, decompile, disassemble, exploit, or
                  otherwise attempt to discover the Location Service or allow
                  any third party to do so. You agree to comply with all export
                  and re-export restrictions and regulations of the Department
                  of Commerce or other US agency or authority and not to
                  transfer or authorize the transfer of the Location Service to
                  a prohibited country or otherwise in violation of any such
                  restrictions or regulations.
                </p>

                <p>
                  By using the Location Service and any data related thereto,
                  you acknowledge and agree that no warranty is being made to
                  you by GeoComply or its licensors, and that any implied
                  warranties of merchantability or fitness for a particular
                  purpose are expressly disclaimed. You also acknowledge that
                  GeoComply and its licensors shall not be liable to you for any
                  indirect, consequential, incidental, or special damages
                  arising out of your use or license of the Location Service,
                  regardless of the theory of liability, including negligence,
                  tort, and strict liability.
                </p>

                <p>
                  You further agree not to remove, alter, or obscure any
                  copyright or other proprietary notices incorporated on or in
                  the Location Service by GeoComply or any of its licensors, or
                  allow any third party to do the same. You also agree not to
                  make the Location Service or any data related thereto
                  available to third parties, or to use it on behalf of third
                  parties through file sharing, hosting, application services
                  provider, service bureau, or any other type of service. You
                  may not transfer or sublicense the Location Service or any
                  data related thereto, nor allow the Location Service or any
                  data related thereto to become subject to any lien.
                </p>

                <p>
                  You agree that you will not make any copies of the Location
                  Service or any data related thereto, except for a single copy
                  for back-up/archival purposes, and such copy must contain all
                  of GeoComply’s and its licensors’ notices regarding
                  proprietary rights. Additionally, you agree to comply with the
                  Google Maps terms and conditions, the Google Legal Notices,
                  and the AUP, as they may be updated from time to time. Lastly,
                  you acknowledge that we reserve the right to use data from
                  GeoComply to aid in any investigation into your online account
                  activity.
                </p>

                <p>
                  The Location Service is available only on selected carriers
                  for mobile devices. The Location Service might not be
                  available if the mobile device is roaming or if mobile data or
                  location services are turned off. Use of VPN tools, rooted or
                  jailbroken devices, artificial location services or any
                  service, tool or script to tamper or fraudulently represent
                  your actual location will be deemed a breach of this Agreement
                  and may result in the suspension or termination of your
                  account. Any transactions made where you or your device has
                  misrepresented your location will be deemed null and void and
                  any prizes won from such transactions deemed null and void.
                  Location coordinate data is transmitted using Secure Socket
                  Layer (“SSL”) technology into password-protected servers. Your
                  data will be subject to the Privacy Policy. For rate
                  information, please contact your carrier, and note that
                  Message and Data rates may apply.
                </p>

                <p>
                  <b>Non-permitted persons:</b>
                </p>

                <p>
                  You are NOT permitted to obtain or retain an account, deposit
                  funds, participate in or process a competition, game or
                  promotion entry at BettDraft if you are:
                </p>

                <p>
                  <li>
                    Listed on or registered on any governmental or state
                    self-exclusion or prohibited activity list.
                  </li>

                  <li>
                    A direct employee of BettDraft, a direct family member of an
                    employee of BettDraft or an employee of a directly
                    associated, affiliated, or contracted company that
                    participates in or supplies services connected with the
                    direct operation of BettDraft.
                  </li>

                  <li>
                    An employee, directly associated with or affiliated with
                    another fantasy or sports betting site or app, have access
                    to market or non-public data that may provide you an
                    advantage.
                  </li>

                  <li>
                    A sports professional, athlete, referee, a person directly
                    involved in the officiating of a game, a team, league or
                    sports body employee or person directly involved in the
                    operation of a league, team or sporting event offered for
                    contest entry at BettDraft. This includes, but is not
                    limited to the NBA, NFL, NCAAB, NCAAC, NHL, MLB, WMBA,
                    WNCAAB, Soccer, Tennis, MMA, Cricket or Golf.
                  </li>

                  <li>
                    You are subject to backup withholding tax because (a) you
                    are exempt from backup withholding; (b) you have not
                    received any notice from the Internal Revenue Service (IRS)
                    that you are subject to backup withholding due to any
                    failure to report interest or dividends, or (c) the IRS has
                    notified you that you are no longer subject to backup
                    withholding. You further agree to immediately notify
                    BettDraft if you become subject to backup withholding at any
                    time before any payments are made to you.
                  </li>

                  <li>
                    A person prohibited from participating pursuant to court
                    order, or any state-sponsored exclusion or self-exclusion
                    list; or
                  </li>

                  <li>
                    A person deemed ineligible, at the sole discretion of
                    BettDraft, because of violations of the Terms and Conditions
                    or House Rules.
                  </li>
                </p>

                <p>
                  If BettDraft determines that you do not meet the eligibility
                  requirements set forth in this section, you will not be
                  authorized to use the Service. Under these circumstances,
                  BettDraft reserves the right to deactivate your account,
                  withhold or revoke the awarding of any prizes associated with
                  your account or limit your ability to withdraw. BettDraft may
                  require you to provide proof of eligibility to participate in
                  accordance with this section prior to receiving a prize. In
                  the event you are unable to provide proof of eligibility or
                  are deemed ineligible to participate, BettDraft may withhold
                  or revoked any prizes won and deactivate any open or current
                  contest entries. In such situations, BettDraft may only return
                  deposited funds or outstanding balances by way of refund to
                  the initial payment method. Prizes won will be forfeited and
                  will not be returned.
                </p>

                <p>
                  To ensure compliance with all applicable laws and regulations,
                  BettDraft reserves the right to retain any prizes revoked in
                  accordance with this section and use them for its anti-money
                  laundering or fraud prevention efforts.
                </p>

                <p>
                  BettDraft employees are permitted to test the user experience
                  through the Service, but they are prohibited from withdrawing
                  any money or prizes. Employee testing is only permitted to
                  take place on private and non-public contests. Relatives of
                  BettDraft employees who share a household are ineligible to
                  participate in paid contests. BettDraft consultants or
                  promoters of the Service are not subject to such limitations
                  when participating in contests, provided that their
                  arrangement with BettDraft prohibits them from accessing any
                  non-public Service data or any other data not made available
                  to all players and they do not have or receive any advantages
                  in their play on the Service.
                </p>

                <p>
                  Individuals who are employees or operators of other daily
                  fantasy sites that offer cash prizes or charge entry fees,
                  including but not limited to FanDuel, Yahoo and DraftKings, as
                  well as those who have access to pre-released or non-public
                  confidential data about game-related information through their
                  affiliation with another daily fantasy site, are prohibited
                  from entering any BettDraft contests that offer real money
                  prizes. If such an individual enters a BettDraft contest,
                  BettDraft will disqualify the entry, withhold any associated
                  prizes, and may report the violation to the regulating body
                  that regulates the state in which the individual entered the
                  contest. BettDraft may also retain information about the
                  entrant to prevent them from entering future BettDraft
                  contests unless and until BettDraft determines, in its sole
                  discretion, that the entrant is no longer affiliated with
                  another daily fantasy site, or no longer has access to
                  pre-release non-public confidential data about game-related
                  information.
                </p>

                <p>
                  Individuals associated with a league or sport, such as
                  employees, athletes, coaches, team management, support
                  personnel (including team physicians), and team owners, are
                  not allowed to participate in any BettDraft contests
                  associated with their respective sports. Individuals who can
                  influence gameplay through ownership interest or game-related
                  employment, such as team owners, referees, league employees,
                  and sports commissioners, are also ineligible to participate.
                  BettDraft reserves the rights to limit access to all sports
                  and competitions for any individuals who meet the criteria set
                  forth in this section.
                </p>

                <p>
                  BettDraft is not sponsored by or affiliated with the National
                  Basketball Association, National Football League, the National
                  Hockey League, Major League Baseball or other sports operating
                  body.
                </p>

                <p>
                  BettDraft provides proactive tools and support designed to
                  promote responsible player actives and a self-managed and
                  controlled player experience. Both the player and internal
                  operations staff can implement and apply restrictions on
                  player accounts, on the player’s behalf or if a BettDraft
                  employee or analyst determines a player to be showing signs of
                  problem gambling. Individuals who have shown signs of problem
                  gambling or have indicated so or requested account exclusion
                  shall not be permitted to participate in competitions,
                  promotion, or contest entries nor able to deposit funds.
                  Withdrawals of account funds will only be processed by
                  BettDraft staff in such situations.
                </p>

                <h4>4. Conditions of participation</h4>

                <p>
                  <b>Account Registration</b>
                </p>

                <p>
                  To participate in a contest on the Service, you must register
                  for an account and provide accurate, current, and complete
                  information about yourself. You are responsible for
                  maintaining and promptly updating the Registration Data to
                  ensure it remains accurate, current, and complete. If
                  BettDraft suspects or determines that your information is
                  inaccurate, incomplete, or not current, BettDraft reserves the
                  right to deny you access to entering contests, depositing or
                  withdrawing funds and / or may deactivate your account at its
                  sole discretion.
                </p>

                <p>
                  Only one account on BettDraft may be established, maintained,
                  used, and controlled by each individual user. Co-ownership or
                  sharing of accounts or account access details is strictly
                  prohibited. If BettDraft determines that you have opened,
                  maintained, used, or controlled more than one account, or have
                  shared access to your account, BettDraft reserves the right to
                  suspend or deactivate any or all of your accounts and revoke
                  any prizes awarded.
                </p>

                <p>
                  Creating an account on BettDraft is only for the purpose of
                  participating in fantasy sports contests. If BettDraft
                  determines, in its sole discretion, that you are depositing
                  funds without the intention of using them in contests on the
                  Service, BettDraft may suspend, limit, or deactivate your
                  account and report such activity to relevant authorities as
                  part of their anti-money laundering and fraud prevention
                  program.
                </p>

                <p>
                  <b>Account Security</b>
                </p>

                <p>
                  When registering for an account at BettDraft, you must provide
                  a valid email address and create a Username and Password.
                  Confirmed access to the supplied email address must be
                  established prior to gaining access to your account. The
                  Username cannot be deemed offensive or contain language that
                  may be offensive to other users. Accounts with such Usernames
                  may be suspended or deactivated at the discretion of
                  BettDraft.
                </p>

                <p>
                  Certain features and areas of the Service require full and
                  verified registration to access. You are responsible for
                  maintaining the confidentiality of your Password, and for any
                  use of your Username and Password, whether by yourself or
                  others. You agree to never use the same Password for the
                  Service as you have used outside of the Service, to keep your
                  Username and Password confidential, to immediately inform
                  BettDraft of any unauthorized use of your account or any other
                  security breach where your details may have been obtained by
                  others, and use only your own Username and Password to access
                  BettDraft. Failure to comply with this Agreement may result in
                  loss or damage, and BettDraft will not be held liable for any
                  losses or damages in the event of unauthorized access.
                  BettDraft may deny access or block any transaction made
                  through use of your account without prior notice, if we
                  suspect unauthorized access. In the event of your data being
                  compromised or unauthorized access is confirmed, BettDraft
                  will require you to change your password before regaining
                  access to your account. BettDraft may also require you to
                  change your Username or email address.
                </p>

                <p>
                  <b>Account Communications and Information</b>
                </p>

                <p>
                  After registering, you may receive commercial and marketing
                  communications from BettDraft. These communications are
                  considered part the service you registered for and may include
                  promotional offers, updates, and other marketing materials.
                  You acknowledge and agree to receive these communications, and
                  to the extent required by law, you may opt-out of receiving
                  them at any time by either using the unsubscribe function on
                  the email or by contacting customer support. If you choose to
                  opt-out, we will remove you from our email list within 72
                  hours. However, even post opt-out, we may still send you
                  transactional emails related to your account operation or as
                  required by applicable law.
                </p>

                <p>
                  <b>Service Disruption</b>
                </p>

                <p>
                  If the BettDraft Service encounters any operational issues,
                  BettDraft reserves the right, at its sole discretion, to
                  disqualify any individual implicated in or relating to the
                  cause and/or to cancel, deactivate, extend, modify, or suspend
                  the Service and select the winner(s) from all eligible entries
                  received. If such cancellation, termination, modification, or
                  suspension of service occurs, notification may be posted on
                  the Site. In the event of BettDraft's failure to comply with
                  any provision of these Terms due to force majeure events such
                  as acts of God, hurricanes, wars, fires, riots, earthquakes,
                  terrorism, acts of public enemies, actions of governmental
                  authorities outside of BettDraft's control (excepting
                  compliance with applicable codes and regulations), or any
                  other force majeure event, such failure will not be considered
                  a breach of these Terms.
                </p>

                <p>
                  <b>Deposits and Withdrawals of Funds</b>
                </p>

                <p>
                  Prior to the deposit of funds for entering a paid contest, you
                  agree to provide us with your full legal name, a valid
                  residential address, date of birth, and social security
                  number, as well as any other information we may need to
                  conduct appropriate identity checks and comply with applicable
                  regulations. We may also require additional government issued
                  documentation and a live taken selfie to verify your account
                  information and identity. You will not be able to deposit
                  funds or participate in contests while your account is being
                  verified. If we are unable to verify your identity, we reserve
                  the right to suspend your account and withhold any funds until
                  successful verification has been completed.
                </p>

                <p>
                  We reserve the right to conduct checks for compliance with our
                  terms, including anti-fraud checks on playing patterns and
                  deposits before processing a withdrawal. We may also request
                  additional information before permitting a withdrawal. You may
                  close your account and withdraw your deposits and winnings at
                  any time and for any reason, subject to these checks.Deposits
                  and player winnings are held in a separate, segregated bank
                  account owned by BettDraft. These funds belong to you and may
                  not be used by BettDraft to cover its operating expenses or
                  for other purposes. Your withdrawals will be made from this
                  segregated bank account, and checks issued from that account
                  may bear the name of BettDraft or BettDraft’s associated
                  subsidiary related to the operation of this account. BettDraft
                  may limit the amount a user can deposit in accordance with
                  state-imposed deposit limits and/or internally imposed deposit
                  limits.
                </p>

                <p>
                  You may from time to time receive bonuses or Free Play Points
                  that can be converted to playable cash funds or exchanges for
                  gift cards. These bonuses and points have a zero ($0.00)
                  monetary value and BettDraft reserves the right to revoke any
                  or all bonuses or points at any time. Funds obtained from the
                  transfer of Free Play Points will not be withdrawable and be
                  subject to a one times playthrough, requiring you to use these
                  funds for contest entries only. Any prize funds won from
                  contest entries using funds obtained from points, will be paid
                  in cash and be fully withdrawable.
                </p>

                <p>
                  <b>Taxation</b>
                </p>

                <p>
                  Winners who have won $600 or more during the previous year are
                  required to provide updated address and social security
                  details to BettDraft annually. These details are necessary for
                  BettDraft to comply with tax regulations and may be shared
                  with the relevant tax authorities. It is your responsibility,
                  not BettDraft's, to file and pay any applicable state and
                  federal taxes on your winnings. BettDraft does not offer tax
                  advice, and no statements in this agreement or on the Service
                  should be construed as such. BettDraft may, where applicable
                  by law, provide the IRS or state regulatory offices with
                  information relating to your winnings.
                </p>

                <p>
                  By agreeing to this Agreement, you are consenting to the
                  electronic delivery of all informational tax forms, such as
                  Form 1099 and Form W-2G.
                </p>

                <p>
                  <b>Publicity</b>
                </p>

                <p>
                  By entering a contest, you agree to allow BettDraft, its
                  service providers, and business partners to use your personal
                  information, including your name, voice, likeness, location,
                  and photograph, in connection with the development,
                  production, distribution, marketing, and promotion of the
                  selected contest and/or other BettDraft contests, unless
                  prohibited by law.
                </p>

                <p>
                  BettDraft and its partners also reserve the right to make
                  public statements about the entrants and winner(s), both
                  on-air, on the internet, or elsewhere, before, during, or
                  after the contest. You acknowledge and agree that BettDraft
                  may announce the winner's name on-air or on any of its
                  websites or other locations at any time in connection with the
                  marketing and promotion of BettDraft or other contests or
                  games operated by BettDraft.
                </p>

                <p>
                  Participation in and winning a prize in connection with a
                  contest will serve as complete compensation for your
                  obligations under this section, and you agree not to seek any
                  fee or impose other conditions on fulfilling these
                  obligations.
                </p>

                <h4>5. Contest and Participation Rules</h4>

                <p>
                  <b>Game of Skill</b>
                </p>

                <p>
                  BettDraft contests are based on skill and require entrants to
                  use their knowledge of relevant professional sports
                  information and fantasy sports rules to accumulate fantasy
                  points and other player based statistics. The winners of each
                  contest are determined by the criteria stated in the rules of
                  that specific contest. Fantasy points and statistics are
                  earned by the performance of individual athletes in sporting
                  events. The individuals who use their skill and knowledge of
                  relevant sports information and fantasy sports rules to
                  achieve a winning result according to the scoring rules for
                  that contest are declared winners. BettDraft contests are not
                  games of chance, but rather games of skill. It is prohibited
                  to use our Services for any form of gambling, sports betting
                  or any game of chance.
                </p>

                <p>
                  <b>Entry fees</b>
                </p>

                <p>
                  Participation in BettDraft contests requires an entry fee in
                  either US Dollars or Free Play Points. The fee will be
                  deducted from your BettDraft account upon opting to
                  participate in a contest. The fee to enter a contest will vary
                  from contest to contest. For some contests, the fee can be
                  decided by the player and the fee will determine the amount
                  the player can win from the prize pool. All contest entries
                  are final. By submitting an entry to a contest, you agree that
                  you have made an active decision to participate in the contest
                  and that you agree to be bound by the terms and conditions and
                  contest rules. Contest entries are non-refundable. By entering
                  a contest, you agree not to seek to obtain a refund or return
                  of your entry fee for any reason.
                </p>

                <p>
                  In the situation where you have selected players in an event
                  that is cancelled entirely, you may be entitled to an entry
                  fee refund depending on the contest rules. Under these
                  circumstances, BettDraft will return your entry fee and cancel
                  your entry into the contest.
                </p>

                <p>
                  <b>Prizes</b>
                </p>

                <p>
                  Once a contest is completed, winners are announced, usually
                  within an hour of the completion of the game from the last
                  active player on their roster or within an hour of the last
                  game of which players can be selected for the contest. Winners
                  can be notified as much as one day later subject to final
                  verification. To be eligible for prizes, participants must
                  comply with applicable rules for the contest, the House Rules
                  and this Agreement. Prizes are added to the winner's account
                  balance, and in case of a tie, the prize is divided equally
                  among the tied participants, unless stated otherwise in the
                  contest rules.
                </p>

                <p>
                  BettDraft offers different types of contests with entry fees
                  and prizes. Prize calculations are based on the entry fee and
                  results at the time of final scoring by BettDraft. Official
                  adjustments made by professional leagues more than 30 mins
                  after the end of the event may not be taken into
                  consideration. BettDraft reserves the right to make
                  adjustments based official stat adjustments, on transmission
                  errors or calculation errors. BettDraft will not delay prize
                  awards or payments in anticipation of any adjustments but may
                  reverse payments if an adjustment changes the initial winning
                  or losing result. Participants are expected to cooperate with
                  efforts to reverse payments if account balances do not allow
                  for the reversal of the initial prize payment.
                </p>

                <p>
                  Substitution or transfer of prizes is not allowed, and any
                  taxes associated with the receipt or use of any prize are the
                  sole responsibility of the winner. If the awarding of any
                  prizes is challenged by legal authorities, BettDraft reserves
                  the right to determine whether to award, remove or adjust such
                  prizes at its sole discretion. In all disputes over
                  determining winners of BettDraft contests, BettDraft Inc acts
                  as the sole judge and its decisions are final and binding.
                </p>

                <p>
                  Prizes won with Free Play Points have no monetary value.
                  Points may be exchanged for bonus cash at BettDraft’s
                  discretion and BettDraft has no obligation to exchange points
                  for cash, bonus cash, vouchers, or any item of monetary value.
                </p>

                <p>
                  <b>Cancelation and Adjustments</b>
                </p>

                <p>
                  Completion of a Contest is necessary for a prize to be
                  awarded. We reserve the right to cancel any contest at any
                  time. In certain circumstances, where a sporting event is
                  cancelled in which players were selected for a contest,
                  BettDraft may cancel entries containing such players or may
                  cancel the contest entirely. In such instances, entry fees
                  will be refunded to entrants unless otherwise stated in the
                  contest Terms and Conditions.
                </p>

                <p>
                  The announcement of winners occurs after the conclusion of
                  each contest, typically within an hour, but can be as long as
                  the following day, and remains subject to final verification.
                  Upon the awarding of prizes and notification of winners, the
                  scoring results will usually remain unchanged. In the event of
                  any official adjustments made by professional leagues,
                  BettDraft may update the results at its sole discretion.
                  However, we reserve the right to adjust results based on
                  transmission errors or irregularities in the information we
                  receive from our stats provider or in our calculation of
                  results. Any adjustments applied may result in the change in
                  the outcome of a contest and the reversal and reissuing of
                  prizes.
                </p>

                <p>
                  <b>Bonuses and Promotions</b>
                </p>

                <p>
                  At BettDraft, we often provide Bonuses or Free Play Points to
                  newly depositing and existing users or for promotional
                  purposes. Bonuses and Free Play Points may be added to a
                  players account at the discretion of BettDraft. If any unused
                  Bonuses remains in the user's account after 30 days of being
                  credited, BettDraft reserves the right to remove them and
                  determine these funds null and void. Free Play Points may be
                  removed after 7 days. Bonuses offered are subject to an expiry
                  date and must be used prior to this date or they will expire
                  and automatically be removed from the player’s account; Except
                  for the daily $5 bonus credit, which does not expire. Bonus
                  funds are solely for entering BettDraft contests and cannot be
                  withdrawn. All bonus funds and Free Play Points have no
                  monetary value. Any winnings from contests entered with bonus
                  funds are considered cash and are fully withdrawable.
                </p>

                <p>
                  If a player requests a withdrawal after receiving a bonus, the
                  remaining bonus balance on the account will immediately be
                  forfeited. Any play with bonus funds obtained by a deposit,
                  where the bonus funds have been consumed and any portion of
                  you initial deposit is withdrawn without play or use in
                  contest entires, we may void the contest entries made with the
                  bonus funds or any winnings obtained from contests entered
                  with the bonus funds. If BettDraft determines that a user has
                  abused the bonus system, their bonuses and any winnings from
                  contest entries made with the bonus funds may be retracted and
                  they may no longer be offered bonuses by BettDraft. Systematic
                  play such as selecting the same sports player stats into
                  multiple rosters and playing all possible combinations to
                  guarantee a payout and convert bonus funds into cash or any
                  similar systematic play with the intent of circumventing the
                  bonus rules will result in voiding of the associated contest
                  entries and removal of any winnings obtained by this play.
                </p>

                <p>
                  BettDraft Points, also known as Free Play Points, are for
                  promotional purposes and issued at our sole discretion,
                  subject to the terms of the promotion. Free Play Points have
                  no monetary value and can only be used to enter Free Play
                  contests. Once a player has accumulated enough Free Play
                  points, that have been won from Free Play contests, they can
                  convert these into Bonus Cash. Conversion rates, minimums and
                  exchange rates may vary, and points are converted at the sole
                  discretion of BettDraft.
                </p>

                {/* <p>
                Bonus Allocation: Users can utilize up to 15% of the entry amount from their bonus balance for each entry.
                 The remaining 85% must be covered by the deposit balance. If the deposit balance has insufficient funds to 
                cover the required amount, users will be prompted to deposit additional funds to proceed with the entry. 
                Winnings from contest entries will be credited directly to the user's deposit balance. Example: A user with a 
                $100 bonus enters a $20 contest. The system allows the user to use $3 from the bonus balance, with the remaining
                 $17 from the deposit balance. If the deposit balance has only $5, the user must deposit an additional $12 to submit 
                 the contest entry. Upon winning, the winnings are credited to the deposit balance.
                </p> */}
                <p>
                  Bonus Allocation: Users can utilize up to 50% of the entry
                  amount from their bonus balance for each entry. The remaining
                  50% must be covered by the deposit balance. If the deposit
                  balance has insufficient funds to cover the required amount,
                  users will be prompted to deposit additional funds to proceed
                  with the entry. Winnings from contest entries will be credited
                  directly to the user’s deposit balance. Example: A user with a
                  $100 bonus enters a $20 contest. The system allows the user to
                  use $10 from the bonus balance, with the remaining $10 from
                  the deposit balance. If the deposit balance has only $4, the
                  user must deposit an additional $6 to submit the contest
                  entry. Upon winning, the winnings are credited to the deposit
                  balance.
                </p>

                <p>
                  <b>Stats Providers</b>
                </p>

                <p>
                  BettDraft utilizes third-parties to provide statistics for
                  most contests. SportsData.io provides statistics for most
                  contests, historical statistics, projections, and final
                  results. BettDraft accepts no responsibility for erroneous or
                  incorrect stats, projections, final stat results or missing or
                  delayed results.
                </p>

                <p>
                  BettDraft makes every effort to ensure the accuracy and
                  timeliness of scoring and stat updates applied to all
                  Contests. However, BettDraft does not guarantee the accuracy
                  of any scoring or stat corrections. Official scores and
                  results will be posted at the conclusion of the sporting event
                  or competition once it has been declared official, and all
                  official box scores and statistics are posted. BettDraft may
                  not retroactively apply any stat corrections posted by either
                  BettDraft's third-party data provider or the official league
                  statistic provider more than thirty (30) minutes following the
                  official conclusion of the sporting event or competition. Such
                  corrections may not be taken into consideration for
                  determining how to score the Contest.
                </p>

                <h4>6. Conduct</h4>

                <p>
                  By using the Services, you agree not to violate the Terms and
                  Conditions, House Rules, Code of Conduct, or any federal,
                  state, local, or international laws or regulations. The
                  Services are solely for personal, non-commercial use, and you
                  are responsible for any activity related to your use of the
                  Services.
                </p>

                <p>
                  BettDraft may, at its sole discretion and without any
                  restrictions, cancel any contests and / or contest entries.
                  Additionally, BettDraft reserves the right to disqualify you
                  from a contest or the entire Service, refuse to award fantasy
                  points or prizes, and require the return of any prizes,
                  suspend, limit, or deactivate your account if your conduct is
                  deemed, at BettDraft's sole discretion, to be improper,
                  unfair, fraudulent, or otherwise adverse to the operation of
                  the Service or detrimental to other users. Improper conduct
                  includes, but is not limited to, falsifying personal
                  information, violating eligible payment method terms,
                  violating any of these rules, accumulating points or prizes
                  through unauthorized methods such as unauthorized scripts or
                  other automated means, tampering with the administration of
                  the Service or trying to tamper with the computer programs
                  associated with the Service, obtaining other entrants'
                  information and spamming other entrants, abusing the Service,
                  or violating this Agreement. The forfeiture and/or return of
                  any prize shall not prevent BettDraft from informing the
                  relevant authorities and/or pursuing criminal or civil
                  proceedings in connection with such conduct.
                </p>

                <p>
                  You acknowledge and agree that you will not engage in any
                  prohibited conduct, which includes but is not limited to:
                </p>

                <p>
                  <li>Copying the Services;</li>

                  <li>
                    Selling, sharing, co-owning, or transferring your Account;
                  </li>

                  <li>
                    Creating derivative works or improvements of the Services,
                    whether or not patentable;
                  </li>

                  <li>
                    Attempting to access the source code of the Site or App;
                  </li>

                  <li>
                    Removing, altering, or obscuring any intellectual property
                    notices from the Site or App;
                  </li>

                  <li>
                    Distributing the Site or App or any of its features or
                    functionality to a third party;
                  </li>

                  <li>
                    Circumventing any copy protection, rights management, or
                    security features in the Site or App;
                  </li>

                  <li>
                    Impersonating someone else or misrepresenting your identity
                    or affiliation;
                  </li>

                  <li>Violating any applicable laws or regulations;</li>

                  <li>
                    Engaging in conduct that restricts or inhibits others from
                    using or enjoying the Site or App;
                  </li>

                  <li>
                    Overburdening, damaging, or impairing the Site or App, or
                    interfering with another user's ability to use it;
                  </li>

                  <li>
                    Using any automatic device or process to access the Site or
                    App;
                  </li>

                  <li>Introducing malicious software or material;</li>

                  <li>
                    Attempting to gain unauthorized access or disrupt any part
                    of the Site or App;
                  </li>

                  <li>
                    Attacking the Site or App with a denial-of-service attack;
                  </li>

                  <li>
                    Interfering with the proper working of the Site or App.
                  </li>
                </p>

                <p>
                  If BettDraft finds that you have violated any of these rules,
                  we may prohibit you from using any or all of the Services. If
                  we suspect or learn of any violations, we may investigate and
                  take legal action, including cooperating with law enforcement
                  agencies. Deliberately damaging the Site or App or interfering
                  with a contest's legitimate operation is a violation of
                  criminal and civil laws, and BettDraft may seek damages and
                  other remedies to the fullest extent allowed by law.
                </p>

                <h4>7. Content Ownership</h4>
                <p>
                  You are solely responsible for any User Content that you
                  upload, post, share, email, transmit, or otherwise make
                  available on the Service, including but not limited to profile
                  information and communications with other users. This means
                  that all User Content, whether privately transmitted or made
                  publicly available, is the sole responsibility of the person
                  from which such User Content originated, and BettDraft will
                  not be liable in any way for any User Content.
                </p>

                <p>
                  BettDraft may or may not pre-screen User Content, but it has
                  the right (but not the obligation) at its sole discretion to
                  pre-screen, refuse, permanently delete, undelete, modify,
                  and/or move any User Content available via the Service.
                  BettDraft and its designees shall have the right to remove any
                  User Content that violates this Agreement or is otherwise
                  objectionable at BettDraft's sole discretion. You acknowledge
                  and agree that you must evaluate, and bear all risks
                  associated with, the use or disclosure of any User Content.
                  You further acknowledge and agree that you bear the sole risk
                  of reliance on any Content available on or through the
                  Service.
                </p>

                <p>
                  By submitting or otherwise making available User Content on or
                  to the Service, you grant BettDraft an irrevocable, fully
                  sublicensable, perpetual, worldwide, royalty-free,
                  non-exclusive license to use, distribute, reproduce, modify,
                  adapt, publish, translate, publicly perform, and publicly
                  display such User Content (in whole or in part), and to
                  incorporate such User Content into other works, in any format
                  or medium now known or later developed.
                </p>

                <p>
                  You agree that you are solely responsible for your
                  interactions with other users of the Service. While BettDraft
                  reserves the right to monitor disputes between you and other
                  users, it has no obligation to do so.
                </p>

                <h4>8. Intellectual property</h4>
                <p>
                  The Software provided by BettDraft is protected by
                  intellectual property rights and You are granted a personal,
                  limited, revocable, non-exclusive, non-assignable,
                  non-transferable, non-sub licensable right to use it in
                  connection with the Services solely on the Online Software and
                  in accordance with this Agreement. You agree not to engage in
                  any Prohibited Activities, including but not limited to
                  copying, redistributing, publishing, reverse engineering,
                  decompiling, disassembling, modifying, translating, attempting
                  to access the source code, or creating derivative works of the
                  source code. Additionally, You shall not sell, assign,
                  sublicense, transfer, distribute, lease, grant a security
                  interest in the Software, or make it available to any
                  third-party.
                </p>

                <p>
                  Furthermore, You shall not export the Software to any country
                  or use the Software in a manner that violates any applicable
                  laws, rules, regulations, or this Agreement. You shall not
                  assert or imply ownership or title rights in the Software, or
                  remove, circumvent, disable, damage, or otherwise interfere
                  with any security-related feature of the Software. Any
                  violation of this Agreement will render You solely liable for
                  any damages, costs, or expenses arising out of or in
                  connection with the Prohibited Activities.
                </p>

                <p>
                  In the event that You become aware of any Prohibited
                  Activities, You shall notify BettDraft immediately and provide
                  reasonable assistance with any investigations BettDraft may
                  conduct. BettDraft is not obligated to advise You of any
                  investigation it conducts and may use social media sites or
                  third-party companies to perform investigations as required.
                  BettDraft may, at its sole discretion, decide to block Your
                  account and withhold all funds based on the outcome of such
                  investigations.
                </p>

                <p>
                  BettDraft own all the brand names associated with the
                  Services, as well as any other trademarks, service marks,
                  trade names, domain names, and logos used in connection with
                  the Services, regardless of the platform (collectively
                  referred to as the "Trademarks"). BettDraft and its affiliated
                  entities (where applicable) retain all rights to such
                  Trademarks. You agree not to use or register the Trademarks,
                  or any marks that may cause confusion with the Trademarks.
                </p>

                <p>
                  BettDraft owns all the rights in the Site Content including,
                  but not limited to, the Software, contest models, images,
                  pictures, graphics, photographs, animations, videos, music,
                  audio, data, and text available or accessible via or in
                  connection with the Service. The Site Content is protected by
                  copyright and/or other intellectual property rights. The
                  Player shall not modify any of the Site Content and shall not
                  copy, distribute, transmit, display, perform, reproduce,
                  publish, license, create derivative works from, transfer or
                  sell any Site Content or information or work contained in the
                  Software or on the Online Software or used in connection with
                  the Service, except as expressly permitted herein. The Player
                  shall not alter, erase, or remove any trademark notices,
                  copyright notices, logos, or other legal or proprietary
                  designations contained on or within the Site Content. You
                  acknowledge that You obtain no rights in the Trademarks or the
                  Site Content, and You may only use the same in complete
                  accordance with this Agreement and solely for the purpose of
                  Your use in connection with the Services.
                </p>

                <p>
                  You agree not to upload, post, email, transmit or otherwise
                  make available through the Service any material or information
                  that infringes any copyright, trademark, trade secret, patent,
                  right of privacy, right of publicity or other right of any
                  person or entity, or impersonates any other person.
                </p>

                <p>
                  BettDraft upholds the intellectual property rights of others
                  and requires all Players of the Service to do the same.
                  BettDraft reserves the right to remove or disable any content,
                  block or deactivate the account of any individual found to
                  have infringed on BettDraft's or a third-party's rights, or
                  that has violated any intellectual property laws or
                  regulations, or any terms and conditions of this Agreement.
                  BettDraft may deactivate the accounts of repeat infringers at
                  any time.
                </p>

                <p>
                  If you believe that any material available on the BettDraft
                  Service infringes upon your copyright or violates your
                  intellectual property rights, you should inform BettDraft by
                  providing the following information:
                </p>

                <p>
                  <li>
                    Identification of the copyrighted work or other intellectual
                    property that you claim has been infringed;
                  </li>
                  <li>
                    Identification of the material on the site or app that may
                    be an infringement with sufficient detail to enable us to
                    locate it;
                  </li>
                  <li>
                    A statement by you indicating that you have a good faith
                    belief that the disputed use is not authorized by the
                    copyright owner, its agent, or the law;
                  </li>
                  <li>
                    A statement by you made under penalty of perjury that (a)
                    the above information in your notice is accurate, and (b)
                    you are the owner of the copyright interest involved or you
                    are authorized to act on behalf of that owner;
                  </li>
                  <li>
                    Your address, telephone number, and email address; and
                  </li>
                  <li>Your physical or electronic signature.</li>
                </p>

                <p>
                  Communications can be sent to:
                  <br />
                  BettDraft inc.
                  <br />
                  1108 - 250 Consumers Road, <br />
                  North York, <br />
                  ON,
                  <br />
                  M2J 4V6, <br />
                  Canada
                  <br />
                </p>

                <h4>9. Representations</h4>

                <p>
                  To access and use the Services and the Software, You must meet
                  the following representations, which You confirm to be true
                  and accurate to the best of Your knowledge and belief:
                </p>

                <p>
                  9.1 You are of Legal Age, as defined in this Agreement, have
                  the capacity to take responsibility for Your own actions, and
                  will be physically present and within the Authorized
                  Jurisdiction when attempting to deposit funds or enter a
                  contest or promotion.
                </p>

                <p>
                  9.2 All information provided by You to BettDraft, including
                  during registration and any subsequent financial transactions,
                  is true, current, correct, complete, and matches the full
                  name(s) on Your payment accounts and identification. You must
                  ensure that funds deposited into Your BettDraft account are
                  not transferred out to a different financial institution
                  unless permitted by applicable law. Additionally, You must
                  have sufficient available funds before conducting any contest
                  entries, as BettDraft does not extend credit to any player.
                  Any changes to the details previously provided by You to
                  BettDraft must be promptly notified. BettDraft may request
                  certain documents from You to verify the details of the source
                  of funds and payment methods, and the authenticity of such
                  documents. Failure to provide or verify any requested
                  documents may result in the cancellation of a withdrawal
                  request. If any information You provide is untrue, inaccurate,
                  misleading, or incomplete, Your account may be immediately
                  deactivated and any future access blocked. Transferring funds
                  to any other player or account holder is prohibited.
                </p>

                <p>
                  9.3 Your account with BettDraft exists solely for Your
                  personal and non-commercial access. You are not permitted to
                  allow any third-party, including relatives, to access or use
                  the Service or App Software by using Your account, password,
                  or identity. Any activities carried out on Your account by a
                  third-party are Your sole responsibility. You must not
                  disclose Your account username or password to any person and
                  take all reasonable steps to prevent such details from being
                  revealed to any person. Should You suspect that a third-party
                  is using Your account or has access to Your account username
                  or password, You must inform us immediately. We will
                  investigate such matters and request Your cooperation during
                  the investigation. You may be held responsible for all
                  transactions and contest entry fees incurred, through the use
                  of your account by a third-party, if BettDraft deems that the
                  access to the account is by a person or persons known to you.
                </p>

                <p>
                  9.4 You are responsible for ensuring the security of Your
                  username and password on Your computer and any device that may
                  be used to access the Software, including Internet access
                  locations. If Your username and password combination is
                  “hacked,” You are accountable for any unauthorized access to
                  Your account that may result from a virus or malware present
                  on the device from which You access Your account. In the event
                  of any possible hacking attempts or security breaches from
                  Your computer or mobile device, You should promptly report
                  them to BettDraft. Maintaining the physical and logical
                  security of Your computer and/or mobile device and configuring
                  their auto-lock features to prevent unauthorized access and
                  use is Your responsibility.
                </p>

                <p>
                  9.5 You possess a full and clear understanding of sports,
                  sports rules, fantasy points calculations, player statistics,
                  fantasy sports and fantasy contests in general. You
                  acknowledge that You are accountable for ensuring the accuracy
                  of the details of contests and contest entries. You agree not
                  to engage in any conduct that may harm BettDraft's reputation
                  or commit any wrongful acts.
                </p>

                <p>
                  9.6 You acknowledge that activities and contest entries
                  through the Service carry the risk of financial loss and that
                  you are fully responsible for such loss. Your use of the
                  Service is solely at your own option, discretion, and risk.
                  You agree that in the event of any loss, you have no claims
                  against BettDraft, our service providers, any affiliated
                  entities, or their respective officers, employees, service
                  providers, agents or affiliates.
                </p>

                <p>
                  9.7 You are responsible for reporting any taxes or other fees
                  to relevant governmental or taxation authorities in connection
                  with any payouts, winnings or prizes received from BettDraft
                  or any related entity. BettDraft is obligated to report
                  certain payouts, winnings, prizes and other payments to state
                  and federal governments.
                </p>

                <p>
                  9.8 You are responsible for all telecommunication network and
                  internet access service fees, as well as any other necessary
                  consents and permissions required for your use of the Software
                  and the Services provided by BettDraft. BettDraft cannot
                  guarantee that the Software will recall your exact status
                  prior to a disconnection event caused by you or any
                  alterations you make to your system or device.
                </p>

                <p>
                  9.9 You must act in good faith at all times when using the
                  Service as well as in your interactions with BettDraft and
                  other players using the Service. If BettDraft determines that
                  you have violated any applicable laws, rules, regulations,
                  terms, conditions, or policies or caused direct or indirect
                  harm or injury to BettDraft or its service providers, or any
                  other player or user of the Service, Website, or Software,
                  BettDraft may, subject to applicable law, deactivate your
                  account and/or use of the Service, as well as any other
                  accounts you hold with BettDraft. BettDraft will be entitled
                  to retain any monies in your accounts, and you waive any
                  claims against BettDraft and its service providers in this
                  regard. This includes waiving any claims for future, indirect,
                  consequential, incidental, or special damages, subject to
                  applicable law.
                </p>

                <p>
                  9.10 You acknowledge and agree that if you choose to
                  self-exclude from the Services, you will not be permitted to
                  access any accounts you have opened with BettDraft or use the
                  Service, nor will you be able to open or use a new account
                  with any other website operated by BettDraft, during your
                  selected self-exclusion period, until the self-exclusion has
                  been lifted and the original account reopened. Unless the
                  Regulators have been otherwise notified of your
                  self-exclusion, BettDraft will be required to report your
                  self-exclusion to them. If you breach the foregoing, BettDraft
                  may block any new account you open with another Service
                  operated by BettDraft, refund any funds you may have deposited
                  (or previously deposited), and will not be liable to refund
                  any funds you may have entered into a contest or won through
                  such account. BettDraft may also report your breach to the
                  Regulators. Any payouts, winnings, prizes, or other payments
                  by a self-excluded player during the player's period of
                  self-exclusion will be impounded by BettDraft, reported to the
                  Regulators, and subject to the Regulator's forfeiture
                  procedures.
                </p>

                <p>
                  9.11 Individuals such as coaches, athletic trainers,
                  officials, players, and other authorized participants in a
                  sporting event subject to contest entries, as well as those in
                  a position with direct involvement with such individuals, are
                  strictly FORBIDDEN from participating in contest entries on
                  the Website or Application.
                </p>

                <p>
                  9.12 By using the Service, you grant BettDraft and/or the
                  Regulators Your CONSENT to monitor and record Your contest
                  entries communications and geographic location information at
                  all times. You hereby WAIVE any claims against the Regulators,
                  BettDraft, and its Affiliates, licensors, or service providers
                  in such regard.
                </p>

                <h4>10. Prohibited Use</h4>

                <p>
                  10.1 By using the Service, you warrant and represent that the
                  funds used for contest entries are obtained from a legal
                  source and that You will not use the Services or App Software
                  as a money transfer system. You also undertake not to engage
                  in any unlawful or fraudulent activities or transactions,
                  including money laundering activities, under the laws of the
                  Authorized Gaming Jurisdiction in which your account was
                  opened, federal laws, the regulations of the Regulators,
                  and/or any directives or instructions of the Regulators. If
                  BettDraft has a reasonable suspicion that You have engaged in
                  unlawful, fraudulent, or improper activities, including money
                  laundering activities or any conduct in violation of this
                  Agreement, Your access to the Services may be blocked
                  immediately, and Your account may be deactivated. BettDraft
                  may also block, forfeit, or turn over any monies held on the
                  account to the relevant governmental authorities. In such
                  circumstances, BettDraft is not obligated to refund any funds
                  (including any deposited funds and/or winnings) or provide
                  access to any free play points or bonuses that may be in Your
                  account. Additionally, BettDraft may, at its sole discretion,
                  prevent You from accessing the Online Software, BettDraft's
                  other websites or servers, or any other services offered by
                  BettDraft. BettDraft may also inform Interested Third-Parties
                  of Your identity and any suspected unlawful, fraudulent, or
                  improper activities, and You may be placed on the Regulator's
                  or BettDraft's exclusion list. You agree to cooperate fully
                  with BettDraft to investigate any such activities.
                </p>

                <p>
                  10.2 The Services and Software provided by BettDraft are
                  equipped with advanced technology to detect and prevent
                  fraudulent or illegal use of the platform. You are strictly
                  prohibited from attempting to breach or circumvent BettDraft’s
                  security measures, and if BettDraft believes that you have
                  violated this clause, it may immediately block Your access to
                  the Services and/or deactivate Your account while conducting
                  any investigations. BettDraft also reserves the right to
                  report any suspicious activity to the appropriate authorities
                  and Interested Third-Parties, and may close all of Your
                  accounts and block You from future use of the Services. If
                  Your account is deactivated, BettDraft is not obligated to
                  refund You any funds (including deposited funds and/or
                  winnings) or provide access to free play points or bonuses,
                  which will be forfeited subject to Regulators’ approval.
                  BettDraft may also prevent You from accessing any of its other
                  websites, servers, or properties, products or services at its
                  sole discretion.
                </p>

                <p>
                  10.3 The use of any tool designed to give you access to
                  non-public information, exchange contest histories of other
                  Players or used in any way in connection with Your use of the
                  Services, whether creating an unfair advantage for You or not,
                  is strictly prohibited. This includes the use of software,
                  external devices, programs, or applications. The use of AI
                  Software in connection with Your use of the Services is also
                  prohibited. BettDraft continually reviews the use of the
                  Services to detect the use of AI Software, and if We believe
                  that it has been used, BettDraft reserves the right, in its
                  sole discretion, to take any action We consider necessary,
                  including immediately blocking of access to the Services and
                  deactivating the offending Player's account.
                </p>

                <p>
                  If Your account is deactivated under these circumstances,
                  BettDraft is under no obligation to refund any funds
                  (including, but not limited to, any deposited funds and/or
                  winnings) or provide access to any free play points or bonuses
                  that may be in Your account. In addition to blocking Your
                  access to the Services and/or deactivating Your account,
                  BettDraft reserves the right, in its sole discretion, to
                  prevent You from accessing the Online Software, BettDraft's
                  other websites or servers, or any other properties, products
                  or services offered by BettDraft.
                </p>

                <p>
                  10.4 If BettDraft has reasonable grounds to suspect that an
                  account or group of accounts is being operated systematically,
                  such as through the use of specific betting techniques or as
                  part of a group effort, BettDraft reserves the right to block
                  or deactivate all related accounts. In such cases, BettDraft
                  is not obligated to refund any funds, winnings, points or
                  bonuses (including deposited funds) that may be associated
                  with the account(s), and such funds and bonuses may be
                  forfeited subject to approval by regulators.
                </p>

                <h4>11. Account </h4>

                <p>
                  11.1 Your account is strictly for personal use only and must
                  not be utilized for professional, business, or commercial
                  purposes. It is your responsibility to secure and preserve the
                  confidentiality of your account information and devices used
                  to access BettDraft’s services. Under applicable laws,
                  regulations, and rules, you acknowledge that your account is
                  for your sole use only, and you shall not share your account
                  information or permit others to place bets on your behalf.
                  Your funds are kept in a segregated account and are not
                  available to any other party, including BettDraft's creditors,
                  to ensure that funds are not intermingled.
                </p>

                <p>
                  11.2 Any transaction that uses your username and password,
                  whether authorized by you or not, will be considered valid.
                  Therefore, it is essential that you maintain the security of
                  your devices, username, password, and access points, and do
                  not disclose your account details to any third-party.
                </p>

                <p>11.3 Funds in your account will not earn any interest.</p>

                <p>
                  11.4 If you do not access your account for three (3)
                  consecutive years, your account will be considered dormant.
                  Once your account becomes dormant, we will mail you a letter
                  to your registered address, informing you that your account
                  will be deactivated, and any remaining funds in your account
                  may be withdrawn. If we are unable to reach you via email or
                  phone, we may attempt to deliver your remaining balance by
                  check issued in your name to your registered address on your
                  account.
                </p>

                <p>
                  11.5 We retain the right to limit, cap or decline any contest
                  entry fee or other transaction made through your account.
                </p>

                <p>
                  11.6 You are prohibited from selling, transferring, or
                  attempting to sell or transfer any payouts, winnings,
                  deposits, bonuses, chips, or prizes, or any related items to
                  any other individual or entity. If we discover any evidence of
                  such activity, we may inactivate your account. In such a
                  situation, we are not obligated to reimburse you for any funds
                  (including deposited funds and winnings), free play points, or
                  bonuses that may be in your account. These funds, free play
                  points, or bonuses may be forfeited.
                </p>

                <p>
                  11.7 Upon request, we will provide you with account statements
                  that detail your account activity.
                </p>

                <p>
                  11.8 Before entering a contest, you must review your entry to
                  ensure its accuracy and that your selections and roster are
                  correct. Your selection and entry are deemed final,
                  non-editable and non-refundable upon successful placement.
                  BettDraft is not liable for any contest entries that were not
                  confirmed by our systems or accepted by BettDraft.
                </p>

                <h4>12. Payment Transactions and Fraud </h4>
                <p>
                  12.1 You are solely responsible for paying all amounts owed to
                  BettDraft and for any fees, expenses, or other charges imposed
                  by payment services. You are not permitted to initiate any
                  chargebacks or deny/reverse any payment you have made to your
                  Skrill account, card deposits, or BettDraft account. If you do
                  so, you must reimburse BettDraft for any losses suffered as a
                  result. In the event of a chargeback, BettDraft reserves the
                  right to suspend your account and void any active contest
                  entries paid for with funds related to the charged back
                  amount. BettDraft reserves the right to reverse any winnings
                  from contests associated with entries paid for with charged
                  back funds and to use all or part of your BettDraft remaining
                  balance post winnings removal to return funds to Skrill or the
                  payment processing bank to cover the costs of the chargeback
                  amount. Chargeback returns may leave your account in a
                  negative balance and you are responsible for covering the cost
                  of the negative balance before you are able to use your
                  account for further contest entries. BettDraft may stop
                  providing Services or withhold payment from certain users or
                  payment methods, including but not limited to debit cards,
                  prepaid cards, or ACH/e-checks, at its sole discretion.
                  BettDraft may collect any amounts owed to BettDraft from any
                  accounts provided by You, including those connected to the
                  Services or financial institutions, without further notice.
                </p>

                <p>
                  12.2 We reserve the right, at our sole discretion, to use
                  third-party electronic payment processors and/or financial
                  institutions to process payments made by and to You in
                  connection with Your use of the Services. You agree to be
                  bound by the terms and conditions of such third-party
                  electronic payment processors and/or financial institutions
                  and any other third-party service providers who provide
                  third-party services through the Services or the Online
                  Software, provided that they do not conflict with the terms of
                  this Agreement. You may be required to provide additional
                  information and identity checks, including providing copies of
                  your government issued identification prior to being permitted
                  to transact with our third-party providers.
                </p>

                <p>
                  12.3 In the event of suspected fraudulent activity, such as
                  the use of stolen credit or debit cards, BettDraft reserves
                  the right to take action at its sole discretion. This may
                  include blocking the Player's account, reversing any payout
                  made, recovering funds from the Player's account, and seeking
                  to recover any losses incurred by BettDraft. BettDraft may
                  also report any payment fraud or other unlawful activity to
                  relevant authorities or entities, including credit reference
                  agencies. BettDraft may use collection services to recover
                  payments. BettDraft will not be liable for any unauthorized
                  use of credit or debit cards, regardless of whether the cards
                  were reported stolen.
                </p>

                <p>
                  12.4 Each deposit into your account must come from a single
                  payment source, such as a debit card, prepaid card, or
                  ACH/e-check. The payment source must be in your name as an
                  account holder.
                </p>

                <p>
                  12.5 By providing your information, you authorize our
                  third-party payment vendors to initiate debit and credit
                  entries to your depository financial institution account.
                  Transactions may post to your account within twenty-four (24)
                  hours. Future debits will only take place when initiated by
                  you, and you will receive a receipt for each debit. You can
                  deactivate this authorization by notifying the third-party
                  payment vendor in writing. Checks or debits returned unpaid by
                  your financial institution are subject to a service charge,
                  which may be collected electronically or through a bank draft
                  from your account.
                </p>

                <p>
                  12.6 All disputes arising out of or related to third-party
                  payment vendor services involving an Player shall be resolved
                  through arbitration under the Commercial Arbitration Rules of
                  the American Arbitration Association, and any judgment
                  rendered by the arbitrator may be entered in any court with
                  jurisdiction. The arbitration will be conducted in English, in
                  accordance with the United States Arbitration Act, and a
                  single arbitrator will be selected in accordance with said
                  rules. The arbitrator will render a decision in accordance
                  with the substantive laws of the State, and the award will be
                  accompanied by a statement of the reasons for the decision.
                  Any arbitration shall proceed on an individual basis only and
                  not as a class action or a representative action. Claims may
                  not be joined or consolidated unless all parties agree to such
                  consolidation in writing. No award or decision will have any
                  preclusive effect on any issues or claims in any dispute with
                  anyone who is not a named party to the arbitration.
                </p>

                <p>
                  12.7 By providing Your phone numbers, residence address and
                  email addresses, you authorize BettDraft and any third-party
                  vendor or their affiliates to contact You using any method,
                  including auto-dialer, pre-recorded messages or other means.
                </p>

                <h4>13. Disputes and Resolutions</h4>
                <p>
                  In order to enable BettDraft to promptly address any concerns,
                  all disputes or claims should be raised with BettDraft’s
                  Customer Service.
                </p>

                <p>
                  You accept and acknowledge that third-party sources may
                  determine the outcomes of events and games, which may be
                  provided through multiple and/or third-party systems and
                  services necessary for the Services. In the event that the
                  result shown on the Software (as installed and operated by
                  Your hardware) differs from the result shown on our server,
                  the result shown on our server shall always take precedence.
                  This is exemplified, but not limited to, the determination of
                  the outcome of events or games by sports data providers. You
                  understand and agree that BettDraft records shall be the
                  ultimate authority in determining the outcomes of events and
                  games, without prejudice to any of Your other rights or
                  remedies.
                </p>

                <p>
                  You acknowledge and agree that BettDraft records shall be the
                  final authority in determining the terms of Your use of the
                  Services. You shall not have the right to dispute BettDraft's
                  decisions regarding such matters, without prejudice to any of
                  Your other rights or remedies.
                </p>

                <h4>14. No Warranty</h4>

                <p>
                  14.1 BettDraft provides the Services, the Online Software, and
                  App Software "as is". BettDraft does not make any express or
                  implied warranties or representations, including but not
                  limited to, implied warranties and conditions of
                  merchantability, satisfactory quality, fitness for a
                  particular purpose, availability, completeness, or accuracy of
                  the Services, the Online Software, or App Software, or
                  infringement of any third-party intellectual property rights
                  or any applicable laws, rules, and regulations. The entire
                  risk as to the use, quality, and performance of the Services,
                  the Online Software, and the Software lies with you.
                </p>

                <p>
                  14.2 BettDraft does not warrant that the Services, the Online
                  Software, or App Software will meet your requirements, be
                  uninterrupted, timely, secure, or error-free, that defects
                  will be corrected, or that the Services, the Online Software,
                  and App Software or the systems, servers, networks, or other
                  infrastructure or communication equipment that makes them
                  available are free of viruses or bugs or represent the full
                  functionality, accuracy, reliability of the materials or as to
                  results or the accuracy of any information obtained by you
                  through the Services, the Online Software or App Software.
                </p>

                <p>
                  14.3 A malfunction voids all payouts. In the event of systems,
                  servers, networks, or other infrastructure or communication
                  equipment errors or malfunctions, bugs or viruses related to
                  account settlement or other elements of the Services, the
                  Online Software, or App Software or resulting in the loss of
                  data or payouts, winnings, promotions, bonuses, prizes, or
                  anything analogous thereto by you or any other damage to your
                  computer or mobile device equipment or software, BettDraft
                  shall not be liable to you and BettDraft may void any and all
                  activity, including but not limited to, contest entries,
                  events or promotions in question and any and all payments,
                  withdrawals, deposits, or other transfers in relation thereto
                  and may take any other action to correct such errors.
                  BettDraft is not required to provide any backup or fail-over
                  infrastructure, network and/or systems, or similar services.
                  You expressly consent to BettDraft voiding any contest entries
                  that are prohibited by applicable law, rules, and regulations
                  and the terms, conditions, and policies of BettDraft,
                  including but not limited to, contest entries on prohibited
                  markets.
                </p>

                <p>
                  14.4 BettDraft is not liable for any acts or omissions made by
                  your internet service provider, telecommunications provider,
                  or other third-party with whom you have contracted to gain
                  access to the server that hosts the Online Software.
                </p>

                <h4>15. Limitations of Liability </h4>

                <p>
                  15.1 By using the Services, the Online Software, and App
                  Software, you acknowledge and agree that it is at your sole
                  option, sole discretion, and risk to use them.
                </p>

                <p>
                  15.2 BettDraft, its affiliated companies, members, employees,
                  partners, directors, agents, subsidiaries, related parties, or
                  any third-party product or service provider (collectively
                  referred to as "Affiliates") or their respective third-party
                  licensors shall not be liable in contract, tort, negligence,
                  or otherwise for any loss or damage arising directly or
                  indirectly from the use of the Software, the Online Software,
                  or the Services, including but not limited to loss of
                  business, loss of profits (including but not limited to loss
                  of or failure to receive anticipated payouts), business
                  interruption, loss of business information, or any indirect,
                  consequential, incidental, or special damages (even if you
                  have notified us of the possibility of such loss or damage).
                </p>

                <p>
                  15.3 BettDraft, its Affiliates, and their respective
                  third-party licensors shall not be liable in contract, tort,
                  negligence, or otherwise for any loss or damage arising
                  directly or indirectly from your use of any link contained on
                  the Online Software or otherwise via the Services. BettDraft,
                  its Affiliates, and third-party licensors are not responsible
                  for the content contained on any internet site linked to or
                  from the Online Software or otherwise via the Services.
                </p>

                <p>
                  15.4 BettDraft, its Affiliates, and their respective
                  third-party licensors shall not be liable to you or any
                  third-party for any modification to, suspension of, or
                  discontinuance of the Services, the Online Software, or App
                  Software.
                </p>

                <p>
                  15.5 If the Services, the Online Software, or App Software
                  fail to operate correctly due to any delay or interruption in
                  operation or transmission, loss or corruption of data or
                  communication or lines failure, misuse of the Services, the
                  Online Software or App Software, error, omission in content,
                  natural disasters, fire, flood, civil commotion, acts of a
                  government, breakdown of power supplies, cyberattacks, labor
                  disputes, or any other factors beyond our control, then: (a)
                  BettDraft, its Affiliates, and their respective third-party
                  licensors will not be responsible for any loss, including but
                  not limited to loss of winnings and any indirect,
                  consequential, incidental, or special damages that may result
                  from such circumstances; and (b) if any such errors result in
                  an increase in winnings owed or paid to you, you are not
                  entitled to the winnings falling within such increase. You
                  must immediately notify BettDraft of the error and repay any
                  winnings credited to your account in error to BettDraft (as
                  directed by BettDraft), or BettDraft may, at its sole
                  discretion, deduct an amount equal to those winnings from your
                  account, set off such amount against any money owed to you by
                  BettDraft or take other action to collect any money owed, as
                  permitted under law, gaming regulations or otherwise by the
                  Regulators.
                </p>

                <h4>16. Breach of terms and conditions</h4>

                <p>
                  You are required to defend, indemnify, and hold harmless
                  BettDraft, its affiliates, third-party service providers,
                  licensors, officers, directors, members, and employees from
                  any claims, demands, liabilities, damages, losses, costs, and
                  expenses, including legal fees, caused by:
                </p>

                <p>
                  <li>
                    Any violation of this Agreement and Additional Rules by You;
                  </li>

                  <li>
                    Any infringement by You of any law or third-party rights;
                  </li>

                  <li>
                    Any use by You or any other person accessing the Services,
                    the Online Software, or App Software using Your username,
                    password, or personal information without Your
                    authorization; or
                  </li>

                  <li>
                    Acceptance of any winnings You are not authorized to
                    receive, whether due to BettDraft's or any third-party
                    service provider's error or omission.
                  </li>
                </p>

                <p>
                  If You breach this Agreement, any Additional Terms, or if
                  BettDraft suspects that You have breached these agreements,
                  BettDraft may, at its sole discretion, forfeit Your winnings
                  and retain any positive balance in Your account to account for
                  any damages or amounts owed by You to BettDraft. Failure to
                  comply with this Agreement may result in disqualification,
                  termination of Your account, and/or legal action against You.
                  BettDraft reserves the right to take any other remedy
                  available.
                </p>

                <h4>17. Duration and Termination</h4>

                <p>
                  This Agreement will become effective upon the completion of
                  the initial registration process and will continue to be in
                  effect as long as BettDraft decides to offer its services and
                  as updated by BettDraft from time to time, unless deactivated
                  according to its terms. BettDraft can deactivate this
                  Agreement and your account (including your username and
                  password) at any time and without prior notice in the
                  following cases:
                </p>

                <p>
                  <li>
                    BettDraft decides, for any reason, to discontinue providing
                    Services in general or specifically to you;
                  </li>

                  <li>
                    BettDraft believes you have violated any terms of this
                    Agreement or any Additional Rules;
                  </li>

                  <li>
                    you have used the Services improperly, abusively or breached
                    this Agreement or any Additional Rules;
                  </li>

                  <li>
                    your account is related to an existing account that has been
                    deactivated, or it is related to inactived accounts;
                  </li>

                  <li>
                    the appropriate law enforcement agency or regulatory body
                    orders BettDraft to do so;
                  </li>

                  <li>
                    or for any other reason BettDraft determines at its sole
                    discretion.
                  </li>
                </p>

                <p>
                  Upon termination of this Agreement, any balance in your
                  account to which you are entitled will be returned to you
                  within a reasonable time of your request, subject to
                  BettDraft’s right to deduct any amounts owed by you to
                  BettDraft, unless otherwise provided herein or as required by
                  law, rule or regulation.
                </p>

                <p>
                  You may deactivate this Agreement and your account (including
                  your username and password) at any time by sending an email to
                  support@BettDraft.com. The deactivation will take effect upon
                  BettDraft deactivating your account (including your username
                  and password), but you will remain responsible for any
                  activity on your account after sending the email requesting
                  termination of your account by BettDraft. You may request
                  withdrawal of funds from your account whether it is open or
                  closed. BettDraft will honor any customer request to withdraw
                  funds by the later of five days after receipt of the request
                  or 10 days after submission of any tax reporting paperwork
                  required by law unless BettDraft believes in good faith that
                  you have engaged in fraudulent conduct or other conduct that
                  would put BettDraft in violation of any regulatory obligation.
                  If winnings are awarded to you with a closed account, those
                  winnings, to the extent that the winnings consist of funds,
                  will be distributed by BettDraft within seven days, except if
                  an account is closed on the basis of BettDraft’s good faith
                  belief after investigation that you have engaged in fraud or
                  have attempted to engage in behavior that would put BettDraft
                  in violation of any regulatory obligation, in which case such
                  winnings may be withheld, provided that the winnings are
                  redistributed in a manner that reflects the outcome that would
                  have resulted had you not participated.
                </p>

                <p>
                  On termination of this Agreement, you shall discontinue the
                  use of the Services, Online Software, or App Software; pay all
                  amounts due and owing to BettDraft; and remove and permanently
                  delete the Software from your computer equipment and/or mobile
                  device and destroy all related documentation in your
                  possession, custody, power or control. The right to deactivate
                  this Agreement by either party shall not prejudice any other
                  right or remedy of either party in respect of the breach
                  concerned (if any) or any other breach. Upon termination of
                  this Agreement, except as otherwise provided in this Agreement
                  and subject to any rights or obligations that have accrued
                  prior to termination, neither party shall have any further
                  obligation to the other party under this Agreement. In
                  addition to terminating your access to the Services and/or
                  blocking your account, BettDraft reserves the right, in its
                  sole discretion, to prevent you from accessing the Services,
                  the Online Software, or App Software, and any of BettDraft’s
                  other websites or servers, and you shall have no claims
                  against BettDraft in such regard.
                </p>

                <p>
                  If you have previously excluded yourself from our responsible
                  gaming program or any other gaming site, including any brands
                  under our Company or state-sponsored programs, it is your
                  responsibility to avoid creating new accounts during your
                  exclusion period. While we will take reasonable measures to
                  prevent access, it is your duty to refrain from opening any
                  accounts with our Company's brands. If you do open new
                  accounts, we will immediately close them. Neither BettDraft
                  nor its Affiliates are required to reimburse any funds that
                  you may have used to enter a contest or won through such an
                  account. You are responsible for indemnifying and protecting
                  BettDraft from all claims, demands, liabilities, damages,
                  losses, costs, and expenses, including legal fees and other
                  expenses, resulting from your failure to follow the
                  self-exclusion.
                </p>

                <h4>18. General</h4>

                <p>
                  18.1 Should any part of this Agreement be deemed invalid,
                  illegal, or unenforceable, it shall not affect the validity of
                  the remaining provisions, which shall remain enforceable
                  according to their terms.
                </p>

                <p>
                  18.2 Any waiver by us of any term of this Agreement shall not
                  be construed as a waiver of any subsequent breach of the same
                  or any other term of this Agreement.
                </p>

                <p>
                  18.3 Unless expressly stated otherwise, this Agreement does
                  not create or confer any rights or benefits on any
                  third-party.
                </p>

                <p>
                  18.4 This Agreement does not create any agency, partnership,
                  trust arrangement, fiduciary relationship, or joint enterprise
                  between You and BettDraft, its affiliates, or third-party
                  licensors
                </p>

                <p>
                  18.5 This Agreement, together with the Privacy Policy and
                  House Rules, represents the entire agreement between BettDraft
                  and You regarding Your use of the Services, the Online
                  Software, or App Software, and supersedes any prior
                  agreements. By accepting this Agreement, You confirm that You
                  have not relied on any representations other than this
                  Agreement, the Privacy Policy, and the Additional Rules.
                </p>

                <p>
                  18.6 BettDraft reserves the right, at its sole discretion, to
                  transfer, assign, sub-license, or pledge this Agreement,
                  wholly or partly, in the event of a corporate reorganization
                  or merger, sale of assets, or similar transaction.
                </p>

                <p>
                  18.7 You agree not to transfer, assign, sub-license, or pledge
                  Your rights or obligations under this Agreement. The Operator
                  and Provider are beneficiaries of this Agreement.
                </p>

                <p>
                  18.8 This Agreement does not grant You any security interest
                  in the assets of BettDraft, including any amounts credited to
                  Your account.
                </p>

                <p>
                  18.9 Depending on state and federal regulations, You may need
                  to complete certain tax forms before receiving winnings
                  exceeding a taxable threshold. By using the Services, the
                  Online Software, or App Software, You agree to comply with all
                  applicable tax laws and release BettDraft from liability
                  associated with such compliance or any actions taken by
                  BettDraft in connection therewith.
                </p>

                <p>
                  18.10 Paragraph and section headings in this Agreement are
                  included for reference only and do not constitute a part of
                  the Agreement, nor do they affect the interpretation or scope
                  of any provision.
                </p>

                <h4>19. INDEMNIFICATION</h4>

                <p>
                  <b>Binding Arbitration and Class Waiver</b>
                </p>

                <p>
                  <b>
                    THE TERMS BELOW LIMIT THE MANNER IN WHICH YOU CAN SEEK
                    RELIEF UNDER THIS AGREEMENT. PLEASE READ THESE TERMS
                    CAREFULLY.{" "}
                  </b>
                  <br />
                  <br />
                  All disputes related to your use of the Online Software or
                  Services, including any past, present, or future dispute,
                  claim, or controversy related to the breach, enforcement,
                  construction, validity, interpretation, enforceability, or
                  arbitrability of this Agreement, the Privacy Policy, or any
                  Additional Rules, shall be resolved through binding
                  arbitration in accordance with the Commercial Arbitration
                  Rules of the American Arbitration Association, except when
                  seeking equitable and other relief for alleged unlawful use of
                  copyrights, trademarks, trade names, logos, trade secrets, or
                  patents. The arbitration shall take place in the Authorized
                  Gaming Jurisdiction where your account was opened and be
                  conducted by a single arbitrator in accordance with the rules
                  of the American Arbitration Association, as modified by this
                  Agreement, the Privacy Policy, or any Additional Rules. The
                  arbitrator's decision will be final and legally binding, and
                  judgment may be entered in any court having jurisdiction. All
                  aspects of the arbitration proceeding will be strictly
                  confidential, and each party shall bear its own costs.
                </p>

                <p>
                  You are generally prohibited from bringing any class,
                  collective, or representative action against us, including
                  participating in or recovering relief under any past, pending,
                  or future class, collective, or representative action against
                  us by someone else. In connection with your use of the Online
                  Software and Services, you agree not to commence a class
                  action, class arbitration, or other representative action or
                  proceeding and hereby waive any and all rights to participate
                  in any past, pending, or future class action or any other
                  consolidated representative proceeding.
                </p>

                <p>
                  By using the Online Software and Services, you automatically
                  agree to the arbitration and class action waiver requirements
                  set forth in this section. If you wish to opt-out of the
                  arbitration or class action waiver requirements, you may do so
                  by contacting support@BettDraft.com within 30 days of first
                  using the Online Software or Services and entering into this
                  Agreement, and providing notification of your intent to
                  opt-out of the arbitration and class action waiver. Your email
                  should contain your full name, address, and the words "OPT
                  OUT" in the body or subject line.
                </p>

                <p>
                  All claims or lawsuits related to the Online Software or
                  Services, including this Agreement, the Privacy Policy, or any
                  Additional Rules, regardless of form, must be filed within one
                  year of the action, omission, event, or occurrence giving rise
                  to the claim or suit. Failure to file such claim or lawsuit
                  within one year of the action will result in the claim or
                  lawsuit being time-barred and prohibited, without regard to
                  any period of limitation or repose by law or statute.
                </p>

                <h4>20. Governing Law and Waiver of Jury Trial</h4>

                <p>
                  This Agreement, including the Additional Rules and Privacy
                  Policy, and the relationship between the parties, and any
                  disputes or controversies arising in connection with the
                  Services, the Online Software or App Software, shall be
                  governed by and interpreted in accordance with the laws of the
                  Authorized Gaming Jurisdiction in which your account was
                  opened, subject to any conflict of laws provisions. By
                  accepting this Agreement, you consent to the exclusive
                  jurisdiction of the courts located in the Authorized Gaming
                  Jurisdiction in which your account was opened, and you agree
                  that any disputes shall be resolved under the personal and
                  exclusive jurisdiction and venue of state or federal courts in
                  the Authorized Gaming Jurisdiction. YOU AND BETTDRAFT HEREBY
                  WAIVE ANY RIGHT TO REQUEST A TRIAL BY JURY IN ANY LITIGATION
                  OR OTHER DISPUTE ARISING OUT OF OR WITH RESPECT TO ANY ASPECT
                  OF THIS AGREEMENT, INCLUDING THE ADDITIONAL RULES AND PRIVACY
                  POLICY. YOU ACKNOWLEDGE THAT YOU HAVE HAD THE OPPORTUNITY TO
                  CONSULT WITH INDEPENDENT COUNSEL WITH RESPECT TO THIS WAIVER.
                </p>

                <h4>21. Disconnection</h4>

                <p>
                  In the event of an Player disconnection from the network
                  server while using the Services, the Online Software, or App
                  Software, the following provisions apply:
                </p>

                <p>
                  <li>
                    If no Player input is required to complete the contest entry
                    and the contest entry is accepted by the Software and
                    BettDraft, the Software and BettDraft's records will
                    determine the acceptance of the contest entry. Upon
                    reconnection, the contest entry will be reflected in the
                    Player's account history.
                  </li>

                  <li>
                    If Player input is required to complete the contest entry
                    and the contest entry is not accepted by the Software and
                    BettDraft, the Software will not record the contest entry.
                    Upon reconnection, the Player can continue to use the
                    Software and provide the necessary input to contest entry,
                    but the contest entry may not be at the same state as prior
                    to the disconnection.
                  </li>

                  <li>
                    If, at the start of entering a contest, the Location Service
                    verifies the Player's physical presence in the Authorized
                    Gaming Jurisdiction, but fails to verify the Player's
                    continued physical presence at a later point in the gaming
                    session, the Software and BettDraft's records will determine
                    the acceptance of the contest entry at the time of the
                    subsequent failed location verification.
                  </li>
                </p>

                <p>
                  You acknowledge and agree that, notwithstanding anything to
                  the contrary, (i) BettDraft and its records will make the
                  final determination regarding any contest activity, including
                  but not limited to, whether a contest entry was placed, stats,
                  fantasy points, and players listed and (ii) BettDraft cannot
                  be held, and you shall not hold BettDraft, liable for any
                  failure of equipment, technology or services, regardless of
                  their physical location or provider, which prevents the
                  placement or acceptance of contest entries or contact with
                  BettDraft.
                </p>

                <h4>22. Errors and Potential Errors</h4>

                <p>
                  BettDraft makes every effort to prevent errors from occurring
                  in relation to contests, which include but are not limited to
                  events, markets, stats, fantasy points, players, teams,
                  entries, acceptance, grading and settlement, and the crediting
                  or debiting of funds to accounts. However, errors may occur
                  due to human, software, and/or system errors, bugs or defects,
                  conflicts or failures of any software or system to operate in
                  accordance with the rules of the relevant event, enrty,
                  product, or service, communication, timing, or display errors,
                  changes in any applicable law, regulations, rules, decisions
                  or policies of a government or sporting agency or body, or any
                  other errors or failures that may arise.
                </p>

                <p>
                  In the event that errors do arise, you acknowledge,
                  understand, and agree that BettDraft has the right to take
                  corrective action, which may include the cancellation,
                  voiding, or refunding of any contest entries or winnings and
                  the crediting or debiting of your account to resolve the
                  error. You agree to cooperate with BettDraft in resolving any
                  errors or potential errors and returning any funds or winnings
                  that may have been paid to you as a result of such errors or
                  potential errors, including BettDraft reclaiming such funds or
                  winnings from your account. BettDraft reserves the right to
                  correct or otherwise resolve any error or potential error in
                  its sole discretion.
                </p>

                <p>
                  For instance, if an error or potential error occurs in the
                  transmission of stats or fantasy points, contest entries will
                  be settled with the correct stats at the time of acceptance as
                  determined by BettDraft. If BettDraft accepts a contest
                  entries on an event where offering contest entries on the
                  event itself was in error or otherwise not permitted,
                  BettDraft may void the contest entry entirely, reverse any
                  winnings credited to your account that are related to such
                  voided entry, and return to you the amount you initially
                  entered a contest.
                </p>

                <p>
                  It is your responsibility to immediately notify BettDraft and
                  to cooperate with BettDraft in resolving any error or
                  potential error related to your contest entries or account
                  activity. If you have used or withdrawn any funds that have
                  been credited or awarded to your account as a result of an
                  error, including the use of such funds for the placement of
                  contest entries, you agree that BettDraft may cancel such
                  contest entries and/or withhold any winnings from such contest
                  entries. You also agree to hold any funds credited to your
                  account from such contest entries in trust for BettDraft and
                  return such funds to BettDraft upon demand for payment by
                  BettDraft.
                </p>

                <p>
                  By using the products or services provided by BettDraft, you
                  acknowledge, understand, and agree that BettDraft reserves the
                  right to cancel, remove, or otherwise change any of the
                  services at any time.
                </p>

                <p>
                  <b>
                    PLEASE ENSURE THAT YOU PRINT AND RETAIN A HARD COPY OF THIS
                    AGREEMENT FOR YOUR RECORDS. BETTDRAFT MAY AMEND THIS
                    AGREEMENT FROM TIME TO TIME, AND YOU WILL BE REQUIRED TO
                    ACKNOWLEDGE YOUR ACCEPTANCE OF ANY SUCH AMENDMENT.
                  </b>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Termsconditions;
